;(function ($, window, document) {
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function resizeBannerPageHeight() {
        if ($('.bannerActive').length) {
            let headerHeight    = $('.bannerActive .af-header').outerHeight();
            const isSticky      = $('.bannerActive .af-header').hasClass( "sticky" );
            const isOpen        = $('.bannerActive .af-header').hasClass( "open" );
            const bannerHeight  = $('.af-header__banner').outerHeight();

            if (isOpen) { // banner hidden so height needs to be added separately
                headerHeight += bannerHeight;
            }

            if ($(window).width() < 992) {
                if (isSticky) headerHeight += 40; // height difference when sticky
            } else {
                if (isSticky) headerHeight += 20; // height difference when sticky
            }

            $('.af-cards-banner').css('margin-top', headerHeight - 20);
            $('.af-banner, .af-loan-banner, .af-state-banner, .af-home__banner').css('margin-top', bannerHeight);
        }
    }

    function startBannerPageHeightResize() {
        $(window).resize(resizeBannerPageHeight);
    }

    function endBannerPageHeightResize() {
        $('.af-cards-banner, .af-banner, .af-loan-banner, .af-state-banner, .af-home__banner').css('margin-top', "");
        $(window).off("resize", resizeBannerPageHeight);
    }

    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    // getting around bug with svg not redrawing on safari
    if(!isIE11 && typeof($(".af-banner__bg")[0]) != 'undefined') {
        let resizeObserver = new ResizeObserver(function() { 
            $('svg.af-banner__bg').css('transform', 'translateZ(0)')
        }); 
        resizeObserver.observe($(".af-banner__bg")[0]);
    }

    var urlParams = window.location.search; //get all URL parameters

    /****************
        document event listeners
    /***************/
    $(document).on('click touch', function (e) {
        /****************
            Search open
        /***************/
        if ($('.af-search').find(e.target).length === 0) {
            search_form.removeClass('open');
            js_search_submit.removeClass('open');
            hide_on_search.removeClass('hidden');
        }
        if(!$(e.target).parent().hasClass('menu-item-has-children')){
            $('.menu-item-has-children').removeClass('menu-item-selected');
        }
    });

    $(document).on('click', '.js-youtube-embed-play', function () {
        const embed = $(this).closest('.af-youtube-embed');
        const iframe = embed.find('iframe').first();

        if (iframe.length === 0) return;

        if (!iframe.attr('src')) {
            iframe.attr('src', iframe.data('src'));
        }

        embed.find('.af-youtube-embed__overlay, .js-youtube-embed-play').hide();
        iframe.show();
    });

    /* ------------------------------------------- */
    /* EDGE BROWSER */
    /* ------------------------------------------- */

    if (document.documentMode || /Edge/.test(navigator.userAgent)) {
        $('body').addClass('af-edge');
    }

    var xxlBPoint = 1500,
        xlBPoint = 1200,
        lgBPoint = 992,
        mdBPoint = 768,
        smBPoint = 576;
        //isMobile = navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i);

    if (typeof pageCalculations !== 'function') {
        var winW,
            winH,
            winS,
            pageCalculations,
            onEvent = window.addEventListener;
    
        pageCalculations = function (func) {
                winW = window.innerWidth;
                winH = window.innerHeight;
                winS = $(window).scrollTop();
    
            if (!func) return;
            onEvent('load', func, true); // window onload
            onEvent('resize', func, true); // window resize
            onEvent('orientationchange', func, false); // window orientationchange
        };
    
        pageCalculations(function () {
            pageCalculations();
        });
    }

    // document.addEventListener('touchstart', function(){}, true);

    /****************
        Navbar on Scroll
    /***************/

    const   js_nav_toggle     = $('.js-nav-toggle'),
            header            = $('.js-header');

    stickyHeader();

    $(window).on('scroll', function() {
        stickyHeader();
    });

    function stickyHeader() {
        if($(window).scrollTop() > 0) {
            header.addClass('sticky');
        } else {
            header.removeClass('sticky');
        }
    }

    /****************
        Navbar open
    /***************/

    js_nav_toggle.on('click', function(){
        $(this).hasClass('active') ? $(this).removeClass('active') : $(this).addClass('active');
        if (header.hasClass('open')) {
            header.removeClass('open'); 
            $('html, body').removeClass('overflow-hidden');
        } else {
            header.addClass('open');
            $('html, body').addClass('overflow-hidden');
        }
    });

    /****************
        Search open
    /***************/

    const   js_search_submit    = $('.js-search__submit'),
            search_form         = $('.af-search__form'),
            hide_on_search      = $('.af-search__hide');

    js_search_submit.each(function(){
        $(this).on('click', function(e){

            let form       = $(this).parent().find('.af-search__form'),
                hide_block = $(this).parents('.js-search__parent').find('.af-search__hide');

            if (!form.hasClass('open')) {
                e.preventDefault();
                $(this).addClass('open');
                hide_block.addClass('hidden');
                form.addClass('open');
                form.find('input').focus();
            }
        });
    })
    

    /****************
        Ripple effect on hover
    /***************/

    const   isMobile = navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i);

    $('.js-af-btn').each(function(){

        let btn     = $(this),
            span    = $(this).find('span');

        function mobileCalculate(object, event) {
            object.on(event, function(e){
                span.css("left", e.originalEvent.touches[0].pageX - btn.offset().left + "px");
                span.css("top", e.originalEvent.touches[0].pageY - btn.offset().top + "px");
            });
        }

        function desktopCalculate(object, event) {
            object.on(event, function(e){
                span.css("left", e.pageX  - btn.offset().left + "px");
                span.css("top", e.pageY - btn.offset().top + "px");
            });
        }

        if(isMobile) {
            mobileCalculate(btn, "touchstart");
        } else {
            desktopCalculate(btn, "mouseover");
            desktopCalculate(btn, "mouseout");
        }
        
    });

    /***************

        Global nav secondary menu

    ***************/
    $('.menu-item-has-children').on('click touch', function(e) {
        if (e.target.toString().indexOf('#') !== -1) {
            e.preventDefault();
        }
     });
    $('.menu-item-has-children').on('mouseover', '*', function (e) {
        if (!navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            var parentdiv = $(this).parent();
            if( parentdiv.hasClass('menu-item-has-children') && !parentdiv.hasClass('menu-item-selected')){
                parentdiv.addClass('menu-item-selected');
            }
        }
    });
    $('.menu-item-has-children').on('mouseout', function (e) {
        if (!navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            if( ! $(e.toElement).hasClass('sub-menu') && 
                ! $(e.toElement).parents().hasClass('sub-menu') && 
                ! $(e.toElement).parent().hasClass('menu-item-selected')) {
                $('.menu-item-has-children').removeClass('menu-item-selected');
            }
        }
    });
    $('.menu-item-has-children').on('touchend', function (e) {
        if( $(e.target).closest('a').length == 0 || 
            e.target.toString().indexOf('#') !== -1 ) {
            $(this).toggleClass('menu-item-selected');
        }
    });


    /* ------------------------------------------- */
    /* BACKGROUND */
    /* ------------------------------------------- */
    window.addImgBg=function(imgSelector, parentSelector) {
        let $parent,
            $neighbor,
            $imgDataHidden,
            $imgDataSibling,
            $this;

        if (!imgSelector) return false;

        $(imgSelector).each(function () {
            $this = $(this);
            $imgDataHidden = $this.data('s-hidden');
            $imgDataSibling = $this.data('s-sibling');
            $parent = $this.closest(parentSelector);
            $parent = $parent.length ? $parent : $this.parent();

            // if <picture> use src of <img> inside
            $src = $this.attr('src') || $this.find('img').attr('src');

            if ($imgDataSibling) {
                $parent.addClass('img-bg-sibling');
                $neighbor = $this.next();
                $neighbor = $neighbor.length ? $neighbor : $this.next();
                $neighbor.css('background-image', 'url(' + $src + ')').addClass('img-bg-sibling__neighbor');
            } else {
                $parent.css('background-image', 'url(' + $src + ')').addClass('img-bg-parent');
            }

            if ($imgDataHidden) {
                $this.css('visibility', 'hidden');
            } else {
                $this.hide();
            }
        });
        
        return false;
    }

    addImgBg('.js-img-bg');

    /* ------------------------------------------- */
    /* - TABS (new widget, js-tab-group/js-tab-nav/js-tab/js-tab-panel) */
    /* ------------------------------------------- */
    // scoped per-instance and nesting-safe
    $('.js-tab-group').each(function() {
        const group = $(this);

        // confirm if tab belongs to this group, not a nested group (return early to prevent bubbling into a parent group)
        function isOwnTab(tab) {
            return tab.closest('.js-tab-group')[0] === group[0];
        }

        // .find() to skip wrapper divs, then filter to match this group, not a nested group (don't deactivate parent/child groups)
        function ownDescendants(selector) {
            return group.find(selector).filter(function() {
                return $(this).closest('.js-tab-group')[0] === group[0];
            });
        }

        function activate(tab) {
            const tabs   = ownDescendants('.js-tab');
            const panels = ownDescendants('.js-tab-panel');

            tabs.removeClass('active').attr('aria-selected', 'false');
            panels.removeClass('active').prop('hidden', true).prop('inert', true);

            tab.addClass('active').attr('aria-selected', 'true');
            const panel = $('#' + tab.attr('aria-controls'));
            panel.addClass('active').prop('hidden', false).prop('inert', false);
        }

        group.on('click', '.js-tab', function() {
            const tab = $(this);
            if (!isOwnTab(tab)) return;
            activate(tab);
        });

        group.on('keydown', '.js-tab', function(e) {
            const tab = $(this);
            if (!isOwnTab(tab)) return;

            const arrowKeys = { ArrowRight: 1, ArrowLeft: -1 };
            const tabs       = ownDescendants('.js-tab');
            const index      = tabs.index(this);
            let targetIndex  = null;

            if (e.key in arrowKeys) targetIndex = (index + arrowKeys[e.key] + tabs.length) % tabs.length;
            else if (e.key === 'Home') targetIndex = 0;
            else if (e.key === 'End')  targetIndex = tabs.length - 1;

            if (targetIndex !== null) {
                e.preventDefault();
                activate(tabs.eq(targetIndex).focus());
            }
        });
    });

    /* ------------------------------------------- */
    /* - TABS (legacy, .js-tabs/.js-tablinks) */
    /* ------------------------------------------- */
    var tablinks = document.getElementsByClassName('js-tablinks');
    for (var i = 0; i < tablinks.length; i++) {
        tablinks[i].addEventListener('click', openPanel, false);
    }

    function openPanel() {
        event.preventDefault();
        var tablinksItems = this.closest('.js-tabs').getElementsByClassName('js-tablist-item');
        var tablistPanels = this.closest('.js-tabs').getElementsByClassName('js-tabpanel');

        for (var i = 0; i < tablinksItems.length; i++) {
            tablinksItems[i].classList.remove('active');
        }

        for (i = 0; i < tablistPanels.length; i++) {
            tablistPanels[i].classList.remove('active');
        }

        this.parentElement.classList.add('active');
        var currentId = this.getAttribute('href');
        currentId = currentId.replace('#', '');
        document.getElementById(currentId).classList.add('active');

        matchElementsHeight();
    }

    /* ------------------------------------------- */
    /* TESTIMONIALS HEIGHT */
    /* ------------------------------------------- */
    function testimonialsHeight() {
        if (winW <= mdBPoint) {
            var minHeight = $('.js-testimonials-thumb').innerWidth();
            $('.js-testimonials-thumb').css('height', minHeight);
        } else {
            $('.js-testimonials-thumb').removeAttr('style');
        }
    }

    /* ------------------------------------------- */
    /* PAGE CALCULATION */
    /* ------------------------------------------- */
    pageCalculations(function () {
        testimonialsHeight();
        matchElementsHeight();
    });

    /* ------------------------------------------- */
    /* LOCATION MAP */
    /* ------------------------------------------- */
    // toggle location branches for google map field
    $('.af-map__marker').on('click', function () {
        const parent = $(this).parent('.af-map__state-name');
        parent.toggleClass('active');
        if (parent.hasClass('active')) {
            let height = parent.siblings('.af-map__branches').find('.af-map__branches-inner').outerHeight();
            parent.siblings('.af-map__branches').height(height);
        } else {
            parent.siblings('.af-map__branches').height(0);
        }
    });

    /* ------------------------------------------- */
    /* EQUAL HEIGHT */
    /* ------------------------------------------- */
    function matchElementsHeight() {
        if ($('.js-match-height').length) {
            $('.js-match-height').each(function( index, element ) {
                var maxHeight = 0;
                var $items = $(element).find('.js-match-height-item');
                $items.each(function( index, element ) {
                    $(element).css('height', 'auto');
                    if ( $(this).height() > maxHeight ) {
                        maxHeight = $(this).innerHeight();
                    }
                });
                $items.css('height', maxHeight);
            });
        };
    }

    /* ------------------------------------------- */
    /* TOGGLE BLOCKS */
    /* ------------------------------------------- */

    const toggleBlockBtns = document.getElementsByClassName('js-toggle-blocks-btn');
    const navHeight = 186;
    for (let i = 0; i < toggleBlockBtns.length; i++) {
        toggleBlockBtns[i].addEventListener('click', function(event) {
            if (!isMobile) {
                toggleBlocks(event, this);
            }
        }, false);
    }
    $('.js-toggle-once-blocks-btn').on('click', function(event){
        toggleAllBlocksOnce(event);
    })

    document.addEventListener('wpcf7mailsent', function(event) {
        // console.log(event);
        //AF-290 P0: Apply Page Calendar Form - JavaScript error fix as id is removed with 
        //the upgraded version 5.4 of Contact Form 7 so we will be using unitTag to get
        //the form Id now (KM - Mar-07-2021)
        var formChooseParent = document.getElementById(event.detail.unitTag).parentElement;
        
        var msg = event.detail.apiResponse.message;
        console.log(event.detail.apiResponse);

        //Remove CF7 default response
        var formChoose = document.getElementById(event.detail.id);
        var elm = $(formChoose).find('.wpcf7-response-output');
        $(elm).remove();
        //console.log(elm);

        if (msg) {
            alert("There was an error trying to submit your form. Please try again later.");
        } else {
            if (formChooseParent.classList.contains('js-toggle-blocks-item')) {
                toggleBlocks(false, formChooseParent, true);
            }

            const parent_class = formChooseParent.className.toString().trim();
            if (window.location.pathname.replace(/[^a-zA-Z0-9]/g,'').toLowerCase() === 'ul' && parent_class === "af-send-message__form") {
                const default_res = $(formChooseParent).find('.wpcf7-response-output');
                $(default_res).remove();

                window.location = '/ul_thankyou';
            }

            $('.af-popup__content').css('display', 'none');
            $('.af-calendar__add form').css('display', 'none');

            if ($(formChooseParent).find('div.ics-download').length !== 0){
                
                getday = $('[name="apptday"]').val(); //get day
                getstarttime = $('[name="appttime"]').val(); //get time
                getendtime = '';
                apptday = '';
                apptstarttime = '';
                apptendtime = '';

                if(getday && getstarttime){
                    
                    /*getday = getday.toLowerCase(); //get day tolowercase
                    getstarttime = getstarttime.toLowerCase(); //get time tolowercase
                    var currentdate = new Date(); //To get current date
                    var getdate =  currentdate.getDate(); //get current date
                    var apptdate = (getday == "today" ? getdate : getdate+1); //select apptdate based on getday*/
                   
                    getstarttime = getstarttime.toLowerCase(); //get time tolowercase
                    console.log("get day is: " + getday);
                    var apptdate = getday;
                    console.log("apptdate is: " + apptdate);

                    //Check if it's midgniht the update getstarttime to 12 am
                    //and also select apptdate becomes nextday so increment by 1
                    if(getstarttime == "midnight"){
                        getstarttime = "12am";
                        //apptdate = apptdate+1;
                    }

                    //get full apptday for example 5/28/2019
                    //js getmonth array is zero based so that's why we did +1
                    //apptday = (currentdate.getMonth()+1) + "/" + apptdate + "/" + currentdate.getFullYear();

                    apptday = apptdate;

                    //assing getendtime as getstarttime so we can replace
                    //things accordingly for now meetings are created for half an hour
                    getendtime = getstarttime;

                    //check if it's am or pm and make changes accordingly
                    if(getstarttime.indexOf('am') !== -1){
                        getstarttime = getstarttime.replace("am", ":00 am");
                        getendtime =  getstarttime.replace(":00 am", ":30 am");
                    }
                    else{
                        getstarttime = getstarttime.replace("pm", ":00 pm");
                        getendtime =  getstarttime.replace(":00 pm", ":30 pm");
                    }

                    //assign day, start and end time
                    apptstarttime = apptday + " " + getstarttime;
                    apptendtime = apptday + " " + getendtime
                    console.log(apptstarttime);
                    console.log(apptendtime);

                    //invoke the ics object and use the functions.
                    //update the copy accordingly if needed
                    //var cal = ics();
                    //cal.addEvent("Appointment with Abby", "Abby sent you a note and a link with everything you need to be prepared", "online", apptstarttime, apptendtime);                   
                    //cal.download("Assurance");

                    window.location = window.location.origin + '/services/icsdownload.php?datestart=' + apptstarttime + '&dateend=' + apptendtime;
                }

            }
        }
    }, false );

    function toggleBlocks(event, element, submit=false) {
        if (event) event.preventDefault();

        let toggleWrapp = $(element).closest('.js-toggle-blocks');
        let toggleWrappOffsetTop = toggleWrapp[0].getBoundingClientRect().top + scrollY;
        let toggleItems = toggleWrapp[0].getElementsByClassName('js-toggle-blocks-item');

        if (toggleWrapp.hasClass('js-toggle-flip')) toggleWrapp.addClass('flipped')

        for (i = 0; i < toggleItems.length; i++) {
            toggleItems[i].classList.toggle('d-none');
            if (submit && toggleItems[i].classList.contains('js-person-submit')) {
                toggleItems[i].classList.add('submit');
            }
        }

        if (!toggleWrapp.hasClass('no-scroll')) {
        // specifically for reverse mortgage form, AF-105 JC
            if ($('.js-toggle-once-blocks').data('toggled-once')) {
                toggleWrappOffsetTop = $('.js-toggle-once-blocks').offset().top - navHeight;
            }
            window.scrollTo({
                top: toggleWrappOffsetTop,
                behavior: 'smooth'
            });
        }
    }
    // specifically for reverse mortgage form, AF-105 JC
    function toggleAllBlocksOnce(event, submit=false) {
        event.preventDefault();
        if($('.js-toggle-once-blocks').length > 0){
            var toggleWrapp = $('.js-toggle-once-blocks'),
                toggleWrappOffsetTop = toggleWrapp.offset().top - navHeight,
                toggleItems = toggleWrapp.find('.js-toggle-blocks-item');
            $('.js-toggle-blocks').removeClass('d-none');
            if(!$('.js-toggle-once-blocks').data('toggled-once')){
                for (i = 0; i < toggleItems.length; i++) {
                    toggleItems[i].classList.toggle('d-none');
                    if (submit && toggleItems[i].classList.contains('js-person-submit')) {
                        toggleItems[i].classList.add('submit');
                    }
                }
                $('.js-toggle-once-blocks').data('toggled-once', true);
            }

            window.scrollTo({
                top: toggleWrappOffsetTop,
                behavior: 'smooth'
            });
            $('.js-toggle-once-blocks-btn').css('display', 'none');
        }
    }

    /* ------------------------------------------- */
    /* POPUPS */
    /* ------------------------------------------- */
    const popupOpen = $('.js-popup-open');

    popupOpen.each(function(){
        let popupId = $(this).attr('href');
        if (popupId[0] !== '#') popupId = '#' + popupId;

        $(this).on('click', function(e){
            e.preventDefault();
            $('.af-popup__content').css('display', 'block');
            $(popupId).removeClass('pop-up-hide');
            $(popupId).addClass('af-popup--active');
            if ($(this).hasClass("af-video__thumbnail")) {
                $('.meet-abby-video').trigger('play');
            }
        });
    });

    $('.js-close-btn').on('click', function(){
        $(this).parents('.af-popup').removeClass('af-popup--active');
        $('.js-link-download').attr('href', '');
        $('.safari-download').css('display', 'none');
        if ($(this).parent().find("meet-abby-video")) {
            $('.meet-abby-video').trigger('pause');
        }
    });

    /* ------------------------------------------- */
    /* Apply Now Popups */
    /* ------------------------------------------- */
    if ($('#apply-now-form').length) { // only change default link behavior when form exists
        // global links (apply page) and fallback for other lo apply links
        $('a[href*="assurance.mymortgage-online.com"]:not(.js-popup-form-open)').each(function() {
            $(this).addClass('af-apply-link'); // add tracking class for WebFX
            triggerApplyNowModal(this);
        });

        // lo page and lo search page
        $('.js-popup-form-open').each(function() {
            triggerApplyNowModal(this);
        });
    }

    function triggerApplyNowModal(applyLink) {
        const popupId = '#apply-now-form';
        const loEmail = $(applyLink).data('lo-email');

        $(applyLink).on('click', function(e) {
            e.preventDefault();

            // update with current link to carry tracking params added by WebFX
            const applicationUrl = $(applyLink).attr('href');

            // lo search page
            if (loEmail) $(popupId + ' .lo-email-input input').val(loEmail);
            if (applicationUrl) $(popupId + ' .application-url-input input').val(applicationUrl);

            $(popupId).removeClass('pop-up-hide');
            $(popupId).addClass('af-popup--active');

            setTimeout(() => {
                $(popupId).find('form input[name="input_1"]').focus();
            }, 100); // start fade in, then focus
        });
    }

    $('.js-form-close-btn').on('click', function() {
        $(this).parents('.af-popup').removeClass('af-popup--active');
    });

    /* ------------------------------------------- */
    /* Downloadable Guides */
    /* ------------------------------------------- */
    $('.js-resources-item:not(.instant-download)').click(function(e) {
        e.preventDefault();

        const leadSource = $(this).data('lead-source');
        const fileUrl    = $(this).attr('href');
        const popup      = $(`#js-popup-resources`);

        popup.removeClass('pop-up-hide').addClass('af-popup--active');
        popup.find('.lead-source input').val(leadSource); // .lead-source is a custom class on the Gravity Form field
        popup.find('.js-link-download').attr('href', fileUrl);

        setTimeout(() => {
            popup.find('form input[name="input_1"]').focus();
        }, 100); // start fade in, then focus
    });

    $(document).on('gform_confirmation_loaded', function(event, formId){
        $(`#js-link-download-${formId}`)[0]?.click();
    });

    /* ------------------------------------------- */
    /* SCROLLED INTO VIEW                           */
    /* Function return boolean value if element is scrolled into view */
    /* ------------------------------------------- */

    function isScrolledIntoView(elem) {
        const docViewTop = $(window).scrollTop();
        const docViewBottom = docViewTop + $(window).height();

        const elemTop = $(elem).offset().top;
        const elemHeight = $(elem).height();
        const elemMiddle = elemTop + elemHeight / 2;
        const result = elemTop >= docViewTop && elemTop <= docViewBottom || elemMiddle >= docViewTop && elemMiddle <= docViewBottom;

        return result;
    }

    /* ------------------------------------------- */
    /* Counter animation                           */
    /* ------------------------------------------- */
    if ($('.js-counter').length) {

        var counterView = false;
        var $counters = $('.js-counter');

        var counterInView = function counterInView() {
            if (!counterView) {
                if (isScrolledIntoView($counters)) {
                    counterView = true;
                    $counters.each(function () {

                        // var width = $(this).width();
                        // $(this).css('width', width);

                        var size = $(this).text().split(".")[1] ? $(this).text().split(".")[1].length : 0;
                        $(this).prop('Counter', 0).animate({
                            Counter: $(this).text()
                        }, {
                            duration: 3000,
                            easing: 'swing',
                            step: function step(now) {
                                $(this).text(parseFloat(now).toFixed(size));
                                if (parseInt($(this).text()) > 999) {
                                    $(this).text(parseInt($(this).text()).toLocaleString('en-US'));
                                }
                            }
                        });
                    });
                }
            }
        };

        counterInView();

        $(window).scroll(function () {
            if (!counterView) counterInView();
        });
    }

    /*********************************
     Accordion
    /********************************* */

    $(".js-accordeon .af-accordeon__item:nth-of-type(1)").each(function(index, value) {
        let accordionHeight = $(this).find('.af-accordeon__text').outerHeight();
        $(this).addClass('af-accordeon__item--open');
        $(this).find('.af-accordeon__body').css('max-height', accordionHeight + "px");
    });

    $('.af-accordeon__item').click(function(e) {
        let closestAccordionItem = $(e.target).closest('.af-accordeon__item');
        let closestAccordionBody = $(closestAccordionItem).find('.af-accordeon__body')
        let closestAccordion = $(closestAccordionItem).closest('.js-accordeon');
        let accordionHeight = $(closestAccordionItem).find('.af-accordeon__text').outerHeight();
        if (closestAccordionItem.hasClass('af-accordeon__item--open')) {
            closestAccordionItem.removeClass('af-accordeon__item--open');
            closestAccordionBody.css('max-height', '0px');
        } else {
            closestAccordion.find('.af-accordeon__item').removeClass('af-accordeon__item--open');
            closestAccordion.find('.af-accordeon__body').css('max-height', '0px');
            $(closestAccordionItem).addClass('af-accordeon__item--open');
            closestAccordionBody.css('max-height', accordionHeight + "px");
        }
    });

     /*********************************
        SCROLL TO BLOCK
     /********************************* */

    // update link before check
    if ($('#branch-los').length) $('header a.af-header__apply').attr('href', '#scroll-to-branch-los');
    if ($('#state-los').length) $('header a.af-header__apply').attr('href', '#scroll-to-state-los');

    const anchorLinks = $('a[href*="scroll-to-"]');

    // Scroll to element from url hash
    const hash = window.location.hash;
    $(window).on('load', function() {
        // delay to fix issue where page scrolls to top after scrolling to element
        if (hash && hash.includes('scroll-to-')) scrollToElement(hash);
    });

    if (anchorLinks.length) {
        anchorLinks.each(function() {
            $(this).on('click', function(e) {
                // e.preventDefault();

                // custom settings for LO page nav
                const data = $(this).data();
                const loNav = data && data.mode === 'lo-page';
                // close menu so we can scroll down
                if (loNav && js_nav_toggle.hasClass('active')) js_nav_toggle.click();

                scrollToElement($(this).attr('href'), loNav);
            });
        });
    }

    function scrollToElement(href, loNav = false) {
        const textOffset  = href.indexOf('scroll-to-');
        const top_align   = href.includes('&mode=top');
        let obj_class     = href.substring(textOffset + 10);

        // allow spaces for nested class selection and remove mode parameter
        obj_class = obj_class.replace('%20', ' ').replace('&mode=top', '');

        if ($('.' + obj_class).length) {
            // reduced offset on mobile
            const offsetMobile = $('header').first().outerHeight() + 10;
            const offsetMod    = (window.innerWidth < 768 || loNav || top_align) ? offsetMobile : $(window).height() / 4;
            const offsetTop    = $('.' + obj_class).offset().top - (offsetMod);
            const body         = $('html, body');
            body.stop().animate({scrollTop: offsetTop}, 500, 'swing');
        }
    }


    $('.js-calendar-btn').on('click', function(e){
        e.preventDefault();
        const message = $(this).parents('.af-calendar__add').find('.af-calendar__message--success');
        const message__error = $(this).parents('.af-calendar__add').find('.af-calendar__message--error');
        const mail_field = $(this).parents('.af-calendar__add').find('.af-calendar__mail');
        if( mail_field.val() ) {
            setTimeout( function(){
                message__error.slideUp(250);
                message.slideDown(250);
                mail_field.val('');
            }, 500);
            setTimeout( function(){
                message.slideUp(350);
            }, 2500);
        } else {
            mail_field.focus();
            setTimeout( function(){
                message__error.slideDown(250);
            }, 100);
        }
    });

    document.addEventListener('wpcf7invalid', function(event) {       
        var formChoose = document.getElementById(event.detail.id);        
        var elm = $(formChoose).find('.wpcf7-response-output');
        $(elm).remove();
    }, false );

    //Banner
    // $('.af-page').addClass('bannerActive');
    // $('.af-header__banner').css('display', 'flex');
    resizeBannerPageHeight();
    startBannerPageHeightResize();

    // hide site banner 
    $('.af-header__banner .af-header__close').click(function(e) {
        e.preventDefault();
    });
    $('.af-header__banner .af-header__close, .af-header__banner .CTA').click(function(e) {
        setCookie("HideSiteBanner", true, 24*60*60*1000); // Expires 1 Day, used in header.php
        $('.af-header__banner').css('display', 'none');
        $('.af-header__banner').css('transform', 'translateY(-100%)');
        endBannerPageHeightResize();
        $('.af-page').removeClass('bannerActive');
    });

    // if there's a video (HomePage or state page)
    if ($('#homePageVideo').length) {

        // A way to scroll to and open "Get Started" in home page
        // var hash = window.location.hash;
        if(hash == "#SpeakWithAnExpert") {
            var scrollToEl = $('.af-round-bg__section-1');
            jQuery(function() {
                if (hash) {
                    console.log(hash);
                    $(window).scrollTop(scrollToEl.offset().top);
                    $('a[href="/loan-officer-detail/"] span').click();
                }
            });
        }
    }

    /*********************************
    TOGGLE MUTE BUTTON
    /********************************* */
    $('.sound-button').click(function(e) {
      e.preventDefault();
        $(this).toggleClass('mute');
        $('#video-with-controls')[0].muted = !$('#video-with-controls')[0].muted;
    });
    $("#video-with-controls").on('volumechange', function(){
        if($(this)[0].muted) {
            $(this).siblings('.sound-button').addClass('mute');
        } else {
            $(this).siblings('.sound-button').removeClass('mute');
        }
    });

    // custom dropdown for send_a_message (sam) block - used in contact form
    $('.af-sam-dropdown').each(function() {
        const dropdown      = $(this);
        const reasonToggle  = dropdown.find('.af-sam-dropdown__toggle');
        const reasonText    = reasonToggle.find('.af-sam-dropdown__toggle-text');
        const reasonList    = reasonToggle.siblings('ul');
        const reasons       = dropdown.find('li button');
        const defaultText   = reasonText.text(); // original placeholder, restored when the real select is reset to its blank option
        // <select> is replaced on AJAX re-render (e.g. on a failed validation), so we need to delegate events to a stable container
        const selectField   = 'form .gfield.contact-reason select';
        const formContainer = dropdown.closest('.af-send-message__content');

        // prevent Enter from implicitly submitting the form
        formContainer.on('keydown', selectField, function(e) {
            if (e.key === 'Enter') e.preventDefault();
        });

        // update the custom UI when the real select changes
        formContainer.on('change', selectField, function() {
            const value = $(this).val();
            const $match = reasons.filter(function() {
                return $(this).data('value') === value;
            });

            reasons.removeClass('active');
            if ($match.length) {
                $match.addClass('active');
                reasonText.text($match.text());
            } else { // restore placeholder value when no match (empty value)
                reasonText.text(defaultText);
            }
        });

        // toggle custom UI visibility
        reasonToggle.on('click', function (e) {
            e.preventDefault();
            $(this).siblings("ul").slideToggle("100");
            $(this).find(".af-sam-dropdown__arrow").toggleClass("active");
            $(this).attr("aria-expanded", $(this).attr("aria-expanded") === "true" ? "false" : "true");
        });

        reasons.on('click', function(e) {
            e.preventDefault();
            const value = $(this).data('value');

            // update the real field when the custom UI changes and fire change so Gravity's conditional logic reacts
            formContainer.find(selectField).val(value).trigger('change');

            reasonList.slideUp(100);
            reasonToggle.find('.af-sam-dropdown__arrow').removeClass('active');
            reasonToggle.attr('aria-expanded', 'false');
        });
    });

    // Gravity's Address field group doesn't offer built-in ZIP code validation, so we enforce a 5-digit numeric input here
    $(document).on('input', '.ginput_address_zip input', function() {
        this.value = this.value.replace(/\D/g, '').slice(0, 5);
    });

    //AF-296 Jun Cho
    // Find A Center Scroll to on search
    if(urlParams.indexOf('search_officer') > -1) {
        let _navBannerHeight = 110;
        let _scrollToElOffset = $('.af-page-search').offset().top - _navBannerHeight;
        $("html,body").animate({scrollTop: _scrollToElOffset}, 500);
    }

    $('#search-zip').submit(function(e) {
        e.preventDefault();

        $('#showresults .apply-loading-gif').removeClass('af-hidden');

        $.ajax({
            url: '/wp-content/themes/assurance-financial/template-parts/forms/find-a-center-search.php',
            type: 'POST',
            dataType: 'html',
            data: {
                search_zip: $('input[name="search_zip"]').val(), 
                contact_page_id: 408,
            },
            success: function (data) {
                $('#showresults > *:not(.keep)').remove();
                $("#showresults").append(data);
            }
        })
        .done(function(res){
            let topOffset = 200;
            window.scrollTo({
                top: $("#showresults")[0].getBoundingClientRect().top + pageYOffset - topOffset,
                behavior: 'smooth'
            });
            $('#showresults .apply-loading-gif').addClass('af-hidden');
        });
    });

    // fix value for form submission
    if ($('option[value="Noon"]').length) {
        $('option[value="Noon"]').attr("value", "12PM")
    }

    /*********************************
     Mortgage Calculators
    /********************************* */

    function onlyNumbers(num){
        if ( /[^0-9]+/.test(num.value) ){
          num.value = num.value.replace(/[^0-9]*/g,"")
        }
    }

    function roundValue(valueToRound){
        let observer = new MutationObserver(function() {
            if (valueToRound.text().indexOf('.') >= 0) {
                valueToRound.text(Math.round(Number(valueToRound.text().replace(/[^0-9.-]+/g,""))));
            }
        })

        observer.observe(valueToRound[0], {characterData: true, childList: true});
    }

    if ($("form.mcalc").length) {
        $('input[name="original_loan_amount"], input[name="new_loan_amount"]').on('keyup', function() {
            onlyNumbers(this);
        })

        const roundValues = ['#emmp_div_span', '#mtax_div_span', '#minsure_div_span', '#va_pi_div_span',
            '#va_mtax_div_span', '#va_emmp_div_span', '#fha_emmp_div_span', '#fha_mtax_div_span', '#mpmi'];

        roundValues.forEach(element => {
            if ($(element).length) roundValue($(element))
        });

        $('.mcalc-half.mcwp-down-payment').append('<i class="js-icon">$</i>');
        $('.mcalc-half.mcwp-taxes').append('<i class="js-icon">$</i>');

        $('.mcalc-half label').each(function() {
            if ($(this).html() == "Down Payment ($)") {
                $(this).html("Down Payment")
            }
            if ($(this).html() == "Annual Taxes ($)") {
                $(this).html("Annual Taxes")
            }
            if ($(this).html() == "Annual Insurance ($)") {
                $(this).html("Annual Insurance")
            }
            if ($(this).html() == "Interest Rate ($)") {
                $(this).html("Interest Rate (%)")
            }
        })
    }

    /*********************************
     Filter LO Search Results
    /********************************* */

    const searchFields = [
        {
            searchInput: '#search-officers-home input',
            classPrefix: 'af-lo-search',
        },
        {
            searchInput: '#search-officers-state input',
            classPrefix: 'state-search',
        }
    ]

    searchFields.forEach(field => {
        enableSearchBox(field.searchInput, field.classPrefix);
    });

    function enableSearchBox(searchInput, classPrefix) {
        if ($(searchInput).length < 1) return

        const searchBox = "." + classPrefix

        $(searchInput).on("input focus", function() {
            const value       = $(this).val().toLowerCase()
            const resultsList = $(`.${classPrefix}-results`)
            const expandClass = `${classPrefix}-expanded-dropdown`
            resultsList.html("")

            if (value.length === 5 && !isNaN(value)) {
                // add spinner while searching
                resultsList.html(
                    `<li class='${classPrefix}-results-spinner'><i class='fa fa-spinner'></i></li>`
                )

                $.ajax({
                    url: "/wp-json/custom/v1/los_by_zip?zip=" + value,
                }).done((locations) => {
                    // if value has changed, don't append results
                    const current_value = $(searchInput).val().toLowerCase()
                    if (current_value !== value) return

                    // remove spinner and append results
                    resultsList.html("")
                    const locations_arr = JSON.parse(locations)

                    // adjust style if results loaded after user clicked outside
                    if (locations_arr.length) $(searchBox).addClass(expandClass)
                    else $(searchBox).removeClass(expandClass)

                    for (const [index, location] of locations_arr.entries()) {
                        if ( index === 10 ) break

                        resultsList.append(`
                            <li><a href="${location["link"]}">
                                ${location["first_name"]} ${location["last_name"]}, ${location["office"]["city"]}, ${location["office"]["state"]}
                            </a></li>
                        `)
                    }
                });
            } else if (value.length > 1) $(`.${classPrefix}-options li`).filter(function() {
                const contaisValue = ($(this).text().toLowerCase().includes(value))
                if (contaisValue) resultsList.append($(this).clone())
            });

            // toggle layout based on results
            if (resultsList.html()) $(searchBox).addClass(expandClass)
            else $(searchBox).removeClass(expandClass)
        });

        $(document).on('click focus', function (e) {
            // close dropdown if clicked outside
            if (!$(e.target).parents(searchBox).length > 0) {
                $(`.${classPrefix}-results`).html("")
                $(searchBox).removeClass(`${classPrefix}-expanded-dropdown`)
            }
        })
    }

    $('.form-track-lead form').on('submit', function() {
        try {
            fbq('track', 'Lead');
        } catch (e) {
            console.error("Error in form-track-lead submit: ", e);
        }
    })
})(jQuery, window, document);
